import axios from 'axios';

// Any API error `detail` that isn't a string (FastAPI 422 arrays, objects) becomes readable text so toasts never crash the page.
const toText = (d) => {
  if (d == null) return d;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e === 'object' ? `${(e.loc || []).filter((x) => !['body', 'query', 'path'].includes(x)).join(' › ') || 'request'}: ${e.msg || JSON.stringify(e)}` : String(e))).join('; ');
  if (typeof d === 'object') return d.msg || d.message || JSON.stringify(d);
  return String(d);
};

axios.interceptors.response.use(undefined, (error) => {
  const data = error?.response?.data;
  if (data && typeof data === 'object' && 'detail' in data && typeof data.detail !== 'string') data.detail = toText(data.detail);
  return Promise.reject(error);
});
